import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  dataSourceIconMap,
  dataSourceLabelMap,
} from '@discover-frontend/constants';
import { QUERY_BUILDER_TYPES } from 'src/modules/query-builder/constants';
import { getBackgroundColor } from 'src/modules/query-builder/utils/dataSource';
import { ToolbarQueryBadge } from '../toolbar-query-badge';

export const QueryDataSource = () => {
  const dataSource = useSelector((state: any) => state.queryBuilder.dataSource);
  const queryBuilderType = useSelector(
    (state: any) => state.queryBuilder.queryBuilderType
  );

  const isConversation = useMemo(
    () => queryBuilderType === QUERY_BUILDER_TYPES.CONVERSATION,
    [queryBuilderType]
  );

  if (!dataSource || isConversation) return null;

  return (
    <ToolbarQueryBadge
      icon={dataSourceIconMap[dataSource]}
      label={dataSourceLabelMap[dataSource]}
      variant="white"
      className={`${getBackgroundColor(dataSource, true)} text-white`}
    />
  );
};
